import React from 'react';
import styles from './index.css';

export default ({title, imgSrc}) => (
<div className={styles.header} style={{background:"url("+imgSrc+") left center no-repeat",backgroundSize: '20px 20px'}}>
    <div className={styles.red_block}></div>
    {title}
</div>
)



// WEBPACK FOOTER //
// ./src/component/subheader/index.js